import React, { useEffect, useState } from "react";
import { Badge, Button, Image, Modal, Tag } from "antd";
import { get } from "../apiService";
import moment from "moment/moment";
import { MdDateRange } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import { BsFillFileEarmarkPostFill } from "react-icons/bs";

const HomePopupNew = () => {
  const [modal2Open, setModal2Open] = useState(false);
  const [data, setData] = useState(null);
  const [visible, setVisible] = useState({ visible: false, image: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fectPopup();
    }, 300);

    return () => clearTimeout(dbounce);
  }, []);
  const fectPopup = async () => {
    const limit = "1";
    const page = "1";
    const action = "fetch";
    const status = "upcoming";
    try {
      const response = await get(
        `/exibition.php?limit=${limit}&page=${page}&action=${action}&status=${status}`
      );
      if (response) {
        setData(response.list[0]);
        setModal2Open(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const exhibition = [
    {
      title: "World Diamond Expo 2024",
      start: "2024-03-12",
      end: "2024-03-15",
      venue: "Dubai International Convention Centre",
      boot_no: "A21",
      booth_name: "Diamond World Pavilion",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "Global Gems & Jewelry Fair 2023",
      start: "2023-09-20",
      end: "2023-09-24",
      venue: "Hong Kong Convention and Exhibition Centre",
      boot_no: "B34",
      booth_name: "Gems & Diamond Showcase",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "International Diamond & Jewelry Expo 2023",
      start: "2023-06-10",
      end: "2023-06-13",
      venue: "Palais des Congrès de Paris",
      boot_no: "C11",
      booth_name: "Paris Diamond House",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "Luxury Diamond Exhibition 2024",
      start: "2024-06-18",
      end: "2024-06-22",
      venue: "Las Vegas Convention Center",
      boot_no: "D58",
      booth_name: "Las Vegas Diamond Show",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "Asian Diamond & Gem Expo 2024",
      start: "2024-09-05",
      end: "2024-09-09",
      venue: "Singapore Expo",
      boot_no: "E73",
      booth_name: "Asian Diamonds Pavilion",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "European Gems & Diamonds Show 2023",
      start: "2023-11-01",
      end: "2023-11-05",
      venue: "Berlin ExpoCenter",
      boot_no: "F21",
      booth_name: "Berlin Diamond Showcase",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "African Diamond Trade Show 2024",
      start: "2024-02-10",
      end: "2024-02-14",
      venue: "Johannesburg Expo Centre",
      boot_no: "G45",
      booth_name: "African Diamond Pavilion",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "Dubai International Jewelry Week 2023",
      start: "2023-07-20",
      end: "2023-07-23",
      venue: "Dubai World Trade Centre",
      boot_no: "H16",
      booth_name: "Dubai Diamond Pavilion",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "International Gem & Jewelry Show 2024",
      start: "2024-08-15",
      end: "2024-08-19",
      venue: "Tokyo International Forum",
      boot_no: "I88",
      booth_name: "Tokyo Diamond Gallery",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
    {
      title: "India Diamond Week 2024",
      start: "2024-12-01",
      end: "2024-12-04",
      venue: "Bombay Exhibition Centre",
      boot_no: "J32",
      booth_name: "Mumbai Diamond Showcase",
      exihibition_image:
        "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    },
    {
      title: "The Diamond Summit 2024",
      start: "2024-10-15",
      end: "2024-10-18",
      venue: "New York Hilton Midtown",
      boot_no: "K50",
      booth_name: "New York Diamond Forum",
      exihibition_image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlFYtXEEoRdHyNzslFBQKPhoCK9In6RTbqy3BqRTG6ZMQyOWwZC3A_4rc6oVk1u7GTs-k&usqp=CAU",
    },
  ];
  return (
    <>
      <Modal
        centered
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        footer={[
          <Button onClick={() => setModal2Open(false)} className="bg-danger text-white">Cancel</Button>,
          <Button
            className="bg-dark text-white"
            onClick={() => navigate("/best-diamond-exhibition")}
          >
            All Exhibitions
          </Button>,
        ]}
        closeIcon={false}
      >
        <h4>UPCOMING EXHIBITIONS</h4>
        {exhibition
          .filter((val) => {
            const startDate = moment(val.start);
            const currentDate = moment(new Date());

            // Exhibition is ongoing
            return startDate.isSameOrAfter(currentDate);
          })
          .map((val, index) => (
            <div className="exhibitionCard" key={index}>
              <div className="cardHeader">
                <h3 style={{ fontSize: "1.1rem" }}>{val.title}</h3>
                <Button
                  className="bg-danger text-white"
                  icon={<BsFillFileEarmarkPostFill />}
                  onClick={() =>
                    setVisible({
                      visible: true,
                      image: val.exihibition_image,
                    })
                  }
                />
              </div>
              <p>
                <span>
                  {moment(val.start).format("MMMM DD YYYY")} -{" "}
                  {moment(val.end).format("MMMM DD YYYY")}
                </span>
              </p>
            </div>
          ))}
        <Image
          width={200}
          style={{
            display: "none",
          }}
          src={`${visible.image}?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200`}
          preview={{
            visible: visible.visible,
            src: visible.image,
            onVisibleChange: (value) => {
              setVisible({ visible: false, image: "" });
            },
          }}
        />
      </Modal>
    </>
  );
};

export default HomePopupNew;
